var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row header-tab"},[_c('div',{staticClass:"row"},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:index,staticClass:"tab-item",class:{'tab-item-active': index === _vm.activeIndex},on:{"click":function($event){return _vm.onTabClick(item, index)}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }